export interface Message {
    id: number;
    text: string;
    author: string;
    author_me: boolean;
    author_type: string;
    last_name: string;
    first_name: string;
    middle_name?: string;
    created_at: string;
    photo?: string;
    channel: string;
    files?: any[];
}